/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React from 'react';
import { handleInput } from '../../helpers/CommonFunctions';
import Label from '../Label';

function Input(props) {
    const { id, value, placeholder, setState, labelName, isMandatory, maxChar, submitSelected, regex, handleRegex, disabled, setSubmitSelected, message, setMessage, className } = props;
    return (
        <>
            <div className="w-full flex flex-col">
                <Label labelID={id} disabled={disabled} labelName={labelName} isMandatory={isMandatory} />
                <input disabled={disabled} data-testid={id} onInput={(e) => {handleRegex === true ? e.target.value = e.target.value.replace(regex, '') : ''}} maxLength={maxChar || ''} autoComplete="off" type="text" id={id} value={value} onChange={(e) => disabled ? '' : handleInput(e, setState, setSubmitSelected, setMessage,submitSelected)}
                    className={`mt-2 ${className || ''} bg-[#F1F2F2] border ${submitSelected && isMandatory && (value.trim() === '' || message !== '') ? 'border-[#B51803]' : 'border-[#797979]'} 
                        py-[10px]  px-[12px] rounded h-[40px] font-normal ${disabled ? 'text-[#A5A5A5]' : 'text-[#333]'} text-sm  outline-0  placeholder:text-sm placeholder:text-[#797979]`} placeholder={placeholder} />
                {maxChar && id !== 'zip_code' && id !== 'user_initials' && id !== 'user_name' && <p className={`font-normal text-xs text-[#A5A5A5] absolute ${(submitSelected && value.trim() === '' && isMandatory) || (submitSelected ) ? 'bottom-0' : '-bottom-[18px]'} right-[8px]`}>{value.length}/{maxChar}</p>}
            </div>
        </>
    );
}

export default Input;